import React, {Component} from 'react';

class InactiveDay extends Component {

  render() {

    const {dia_semana} = this.props;

    return (
      <div className={this.getClassName(dia_semana)}/>
    );

  }

  getClassName(dia_semana) {

    if ( dia_semana === 5 || dia_semana === 6 ) {
      return 'calendar-day weekend'
    }
    return 'calendar-day'

  }

}

export default InactiveDay;
